var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "searchDropdown",
      class: {
        searchDropdown: true,
        "searchDropdown--fit": _vm.element === _vm.SORT_FILTER,
      },
      on: {
        keydown: [
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter") &&
              _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
            )
              return null
            return _vm.selectValue(_vm.options[_vm.selectedResult])
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
            )
              return null
            $event.preventDefault()
            _vm.open = false
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "down", 40, $event.key, [
                "Down",
                "ArrowDown",
              ])
            )
              return null
            $event.preventDefault()
            return _vm.selectDown.apply(null, arguments)
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
            )
              return null
            $event.preventDefault()
            return _vm.selectUp.apply(null, arguments)
          },
        ],
        focus: function ($event) {
          _vm.open = true
        },
        blur: function ($event) {
          _vm.open = false
        },
      },
    },
    [
      _c(
        "button",
        {
          staticClass: "searchDropdown__buttonArea selected",
          class: {
            "searchDropdown__buttonArea--bordered": _vm.bordered,
            open: _vm.open,
            "selected--disabled": _vm.disabled,
            "selected--bordered": _vm.bordered,
          },
          attrs: { disabled: _vm.disabled },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.toggleOpen.apply(null, arguments)
            },
          },
        },
        [
          _vm.element === _vm.SORT_FILTER
            ? _c(
                "span",
                { staticClass: "inlineDropdown__label padding-right-5" },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.trans("FORM_SEARCH_SORT_METHOD")) +
                      ":\n        "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              class: {
                selected__label: true,
                "selected__label--bold": _vm.element === _vm.SORT_FILTER,
              },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.currentValue?.name ?? _vm.currentValue?.label) +
                  "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "svg",
            {
              class: { selected__icon: true, "selected__icon--open": _vm.open },
              attrs: { height: "16px", width: "16px", "aria-hidden": "true" },
            },
            [_c("use", { attrs: { href: "#iconChevronDownBold" } })]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "customDropDownOptions",
          staticClass: "searchDropdown items items--shadow",
          class: {
            selectHide: !_vm.open,
            "items--active": _vm.open,
            "items--bordered": _vm.bordered,
            "items--leftAligned": _vm.element !== _vm.SORT_FILTER,
          },
          attrs: {
            id: "customDropDownOptions",
            "aria-labelledby": "searchCustomDropdown",
            "aria-controls": "searchDropDownOptions",
            "aria-expanded": _vm.open,
          },
        },
        _vm._l(_vm.options, function (option) {
          return _c(
            "button",
            {
              key: option.name ?? option.label,
              ref: "searchDropDownOptionValue",
              refInFor: true,
              staticClass: "searchDropdown__button text-ellipsis",
              attrs: {
                id: `${_vm.element}option--${option.value}`,
                type: "button",
                "data-gtm": `${_vm.element}option--${option.value}`,
                disabled: option.value < _vm.DISABLE_DROPDOWN,
                "aria-selected": _vm.isSelected(option),
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.selectValue(option)
                },
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  $event.preventDefault()
                  return _vm.selectValue(option)
                },
              },
            },
            [
              _vm.type === _vm.RADIO_TYPE
                ? _c(
                    "span",
                    { staticClass: "searchRadioContainer text-ellipsis" },
                    [
                      _c("input", {
                        staticClass: "searchRadioContainer__input",
                        attrs: {
                          type: "radio",
                          name: `${_vm.element}option--${option.value}`,
                        },
                        domProps: { checked: _vm.currentValue === option },
                        on: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.selectValue(option)
                          },
                          click: function ($event) {
                            return _vm.selectValue(option)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "outerCircle" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "searchRadio__option" }, [
                        _vm._v(_vm._s(option.name ?? option.label)),
                      ]),
                    ]
                  )
                : _c("span", { staticClass: "margin-left-5 margin-right-5" }, [
                    _c("label", { staticClass: "searchCheckbox" }, [
                      _c("input", {
                        attrs: { type: "checkbox" },
                        domProps: { checked: _vm.currentValue === option },
                      }),
                      _vm._v(" "),
                      _vm._m(0, true),
                      _vm._v(
                        "\n                    " +
                          _vm._s(option.name ?? option.label) +
                          "\n                "
                      ),
                    ]),
                  ]),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "searchCheckbox__border" }, [
      _c("span", { staticClass: "searchCheckbox__icon" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }